<template>
  <div id="place-order">
    <div id="place-order-header">
      <div v-if="addAddress" class="place-header-detail">
        无默认收货地址
        <span class="add-address" @click="modifyAddress">添加收货地址</span>
      </div>
      <div v-else class="place-header-detail" @click="modifyAddress">
        <div class="detail-info">
          <div class="username">
            <span>{{ username }}</span> <span style="margin-left: 40px">{{ tel }}</span>
          </div>

          <div class="address">
            {{ address }}
          </div>
        </div>

        <img class="icon" src="../../assets/common_next.png" alt=""
             style="background: #faf2ed">

        <div style="clear:both;"></div>
      </div>
    </div>
    <div>
      <div class="sheet-image-info">
        <div class="sheet-image">
          <el-image style="width: 15vh; height: 15vh" :src="packageDetail.imageUrl" :preview-src-list="[packageDetail.imageUrl]"/>
        </div>
        <div class="sheet-info">
          <div class="package-name">
            {{ packageDetail.packageName }}
          </div>
          <div class="spec-content">
            <div v-for="(spec, index) in specList" :key="index">
              {{ spec }}
            </div>
          </div>
          <div style="font-size: 14px; text-align: left;">
            (详情请点击图片查看)
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>

      <div v-if="packageDetail.packageType === PACKAGE_TYPE.HAS_PURCHASE_GOODS">
        <div v-for="(item, index) in packageDetail.packageAddPurchaseGoodsList" :key="index">
          <div class="sheet-image-info">
            <div class="sheet-image">
              <el-image style="width: 15vh; height: 15vh" :src="baseUrl + item.goodsImage" :preview-src-list="[baseUrl + item.goodsImage]"/>
            </div>
            <div class="sheet-info">
              <div class="package-name">加价购商品</div>
              <div class="spec-content">
                <div>{{ item.goodsName }}</div>
                <div v-if="item.goodsName === 'hello kitty 抱枕被'">
                  本款抱枕被为固定活动专供搭配售卖，不能单独用于活动以外售卖，因此吊牌印有非卖品字样，介意慎拍
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="quantity-container">
      <span class="quantity-label">数量：</span>
      <div class="explain-number">
        <div class="add" @click="handleReduce">
          -
        </div>
        <div class="number">
          {{ quantity }}
        </div>
        <div class="add" @click="handleAdd">
          +
        </div>
      </div>
    </div>
    <div class="payment-container">
      <div class="payment-left">
        <div class="total-price">结算金额：￥{{ totalPrice }}</div>
        <div class="payment-method">支付方式：与益力多姐姐现金交易</div>
      </div>
      <div class="payment-right">
        <button @click="packageOrderTip">提交订单</button>
      </div>
    </div>


    <!--套餐下单提示-->
    <base-dialog v-if="packageOrderVisible" :title="title" display="none" width="80%" @close="close">
      <div class="tip" style="padding-bottom: 10px">本次商品价格为益力多产品+{{packageDetail.packageAddPurchaseGoodsList[0].goodsName}}价格</div>
      <div class="message" style="padding-bottom: 10px">合计￥{{ totalPrice }}</div>
      <div v-if="packageDetail.packageAddPurchaseGoodsList[0].goodsName === 'hello kitty 抱枕被'" class="message" style="padding-bottom: 10px">本款抱枕被为固定活动专供搭配售卖，不能单独用于活动以外售卖，因此吊牌印有非卖品字样，介意慎拍</div>
      <div class="message" style="padding-bottom: 10px">支付方式为线下支付，请确认是否需要订购</div>
      <button class="tip-cancel" @click="close">取消</button>
      <button class="tip-ok" @click="submitPackageOrder" :disabled="packageOrderBtnDisable">确认</button>
    </base-dialog>

    <base-dialog v-if="deliverVisible" :title="title" width="80%" @close="deliverClose">
      <p class="tip" style="font-size: 1.3rem">温馨提示</p>
      <p class="tip">今天是非配送时间，下单后预计配送时间为{{ deliverMessage }}</p>
    </base-dialog>

    <div class="toast" v-show="toastShow">
      {{toastText}}
    </div>
  </div>
</template>

<script>

import {PACKAGE_TYPE} from "../../store/mutation-types";
import {PackageDetail} from "../../api/Package";
import {BASE_URL} from "@/config/app";
import {SubmitPackageOrder} from "../../api/PackageOrder";
import BaseDialog from "@/components/BaseDialog";
import {OrderDeliver} from "../../api/Orders";
import {AddressDefault} from "@/api/Address";
import {starPhone} from "@/unitls";

export default {
  name: "PackagePlaceOrder",
  components: {BaseDialog},

  data() {
    return {
      packageId: this.$route.query.id,
      packageDetail: {
        spec: ""
      },
      packageOrderVisible: false,
      title: '提示',
      packageOrderBtnDisable: false,
      addAddress: false,
      username: '',
      tel: '',
      address: '',
      addressId: 0,
      quantity: 0,
      toastShow: false,
      toastText: '',
      deliverVisible: false,
      deliverMessage: '',
      baseUrl: BASE_URL,
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
    }
  },

  computed: {
    PACKAGE_TYPE() {
      return PACKAGE_TYPE
    },
    specList() {
      return this.packageDetail.spec.split(' ');
    },
    totalPrice() {
      return parseFloat((this.packageDetail.preferentialPrice * this.quantity).toFixed(2));
    }
  },
  mounted() {
    this.initAddress()
    this.requestPackageDetail()
    this.requestOrderDeliver()
  },

  beforeDestroy() {
  },

  methods: {
    initAddress() {
      let addId = localStorage.getItem('addressId');
      if (addId == null || addId === '') {
        //获取用户默认收货地址
        this.requestMemberDefaultAddress();
      } else {
        this.addressId = localStorage.getItem('addressId');
        this.username = localStorage.getItem('username');
        this.address = localStorage.getItem('userAddress');
        this.tel = localStorage.getItem('userPhone');
      }
    },
    requestMemberDefaultAddress() {
      AddressDefault()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              if (response.data) {
                this.addressId = response.data.id;
                this.username = response.data.consignee;
                this.tel = starPhone(response.data.mobile);
                this.address = response.data.area + response.data.address;
              } else {
                this.addAddress = true;
              }

            }
          })
    },

    // 查询套餐详情
    requestPackageDetail() {
      const packageId = this.packageId;
      PackageDetail({packageId}).then(res => {
        if (res.code === this.$API_CODE.OK) {
          this.showPackageRule = true;
          const packageDetail = {};
          packageDetail.packageId = res.data.id;
          packageDetail.deliveryPeriod = res.data.deliveryPeriod;
          packageDetail.gift = res.data.gift;
          packageDetail.imageUrl = BASE_URL + res.data.image;
          packageDetail.packageName = res.data.packageName;
          packageDetail.priceSum = res.data.priceSum;
          packageDetail.spec = res.data.spec;
          packageDetail.preferentialPrice = res.data.preferentialPrice;
          packageDetail.packageAddPurchaseGoodsList = res.data.packageAddPurchaseGoodsList;
          packageDetail.packageType = res.data.packageType;
          this.packageDetail = packageDetail;
          console.log(this.packageDetail.packageType === PACKAGE_TYPE.HAS_PURCHASE_GOODS);
        }
      })
    },

    // 提交套餐订单
    submitPackageOrder() {
      this.packageOrderBtnDisable = true
      SubmitPackageOrder({
        packageId: this.packageDetail.packageId,
        addressId: this.addressId,
        quantity: this.quantity,
        source: 0
      }).then(res => {
        if (res.code === this.$API_CODE.OK) {
          this.messageVisible = false
          let orderId = res.data.orderId;
          let orderNumber = res.data.orderNumber;
          let orderData = res.data.forecastDeliverTime;

          this.packageOrderBtnDisable = false
          this.packageOrderVisible = false

          this.$router.push({path: '/packageOrderSuccess', query: {orderId, orderNumber, orderData}});
        } else {
          this.packageOrderVisible = false
          this.messageVisible = false
          this.toast(res.message)
          this.packageOrderBtnDisable = false
        }
      })
    },

    // 显示套餐提交提示
    packageOrderTip() {
      if(this.quantity <= 0) {
        this.toast('请选择购买数量')
        return;
      }

      if (this.addAddress) {
        this.toast("请添加收货地址")
        return;
      }
      this.packageOrderVisible = true;
      this.title = '提示';
    },

    modifyAddress() {
      let addId = localStorage.getItem('addressId');
      if (addId !== null && addId !== '') {
        localStorage.setItem('addressId', this.addressId);
      }
      // 保存备注内容
      localStorage.setItem("remark", this.remark);

      this.$router.push({path: '/addressChoose', query: {}})
    },

    handleReduce() {
      if (this.quantity > 0) {
        this.quantity--;
      }
    },
    handleAdd() {
      this.quantity++;
    },

    close() {
      this.packageOrderVisible = false;
    },

    deliverClose() {
      this.deliverVisible = false;
    },

    toast (e) {
      let _that = this;
      this.toastText = e;
      this.toastShow = true;
      setTimeout(function(){
          _that.toastShow = false;
      }, 1500)
    },

    requestOrderDeliver() {
      OrderDeliver()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              if (response.data.ladysHolidayFlg) {
                this.deliverVisible = true;
              } else {
                this.deliverVisible = false;
              }
              this.deliverMessage = response.data.forecastDeliverTime;
            }
          });
    },
  }

}
</script>

<style scoped lang="scss">

#place-order-header {
  padding: 15px 30px;
  background: url("../../assets/address.png") no-repeat;
  background-size: 100% auto;
  /*height: 8rem;*/
  width: 100%;

  .place-header-detail {
    background: #faf2ed;
    /*margin-top: 15px;*/
    border-radius: 5px;
    padding: 15px 10px 15px 10px;
    text-align: center;

    .add-address {
      background: #ea2d53;
      padding: 8px 12px;
      border-radius: 5px;
      color: #FFFFFF;
      font-weight: bold;
      font-size: 1rem;
      margin-top: -8px;
      float: right;
    }

    .detail-info {
      //float: left;

      .username {
        text-align: left;
        font-size: 0.8rem;
      }

      .address {
        text-align: left;
        font-size: 0.7rem;
        margin-top: 5px;
        color: #ea2d53;
        float: left;
        width: 80%;
      }
    }

    .icon {
      margin-left: 10px;
      margin-top: 15px;
      float: right;
    }
  }
}


.sheet-image-info {
  width: 100%;
  position: relative;
  display: flex;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  margin: 10px 0;

  .sheet-image {
    width: 33.33%;
    display: flex;
    align-items: center;

    img {
      width: 15vh;
      height: 15vh;
    }
  }

  .sheet-info {
    width: 66.67%;
    padding-left: 10px;

    .package-name {
      font-size: 18px;
      text-align: left;
      margin-bottom: 10px;
      color: #ea2d53;
    }
  }
}

.spec-content {
  padding: 10px 0;
  font-size: 14px;
  text-align: left;

  div {
    margin-bottom: 5px;
  }
}

.payment-container {
  position: fixed;
  bottom: 10px;
  left: 50%;
  width: 100%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .payment-left {
    text-align: center;
    width: 70%;
    .total-price {
      font-size: 18px;
      color: #ea2d53;
      font-weight: bold;
    }

    .payment-method {
      font-size: 14px;
      color: #666;
      white-space: nowrap;
    }
  }

  .payment-right {
    width: 30%;
    button {
      width: 100%;
      background-color: #ea2d53;
      color: #ffffff !important;
      font-size: 16px !important;
      padding: 10px 20px;
    }
  }
}

.quantity-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;

  .quantity-label {
    font-size: 23px;
    color: #ea2d53;
    margin-right: 10px;
  }

  .explain-number {
    .add {
      float: left;
      width: 40px;
      height: 33px;
      line-height: 33px;
      border: 1px solid #ea2d53;
      text-align: center;
      color: #ea2d53;
      font-size: 1.5rem;

      &.disabled {
        background-color: #f5f5f5;
        color: #cccccc;
        border-color: #cccccc;
      }
    }

    .number {
      width: 40px;
      height: 33px;
      float: left;
      border: 1px solid #ea2d53;
      line-height: 33px;
      text-align: center;
      font-weight: bold;

      &.disabled {
        background-color: #f5f5f5;
        color: #cccccc;
        border-color: #cccccc;
      }
    }
  }
}

.tip {
  padding-top: 15px;
  padding-bottom: 25px;
  color: #ea2d53;
  font-size: 1rem;
  font-weight: bold;
}

.tip-cancel {
  float: left;
  width: 45%;
  color: #ffffff;
  padding: 10px 0;
  background: #ea2d53;
  border-radius: 5px;
}

.tip-ok {
  width: 45%;
  float: right;
  color: #ffffff;
  padding: 10px 0;
  background: #ea2d53;
  border-radius: 5px;
  border: none;
}

.toast{
  position: fixed;
  z-index: 2000;
  left: 50%;
  top:50%;
  transition:all .5s;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  -o-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
  border-radius: 5px;
  color:#FFF;
  background: rgba(17, 17, 17, 0.7);
  padding: 1rem;
  font-size: 1rem;
  line-height: 1.5rem;
}
</style>
